import { Instance } from 'mobx-state-tree';
import { EmailTemplateDtoModelBase } from './EmailTemplateDtoModel.base';
import getAppRoot from '../utils/getAppRoot';
import { enrichTemplateWithOrganizationData } from '../../../helpers/customerNotificationEvents';

/* The TypeScript type of an instance of EmailTemplateDtoModel */
export interface EmailTemplateDtoModelType extends Instance<typeof EmailTemplateDtoModel.Type> {}

/* A graphql query fragment builders for EmailTemplateDtoModel */
export { selectFromEmailTemplateDto, emailTemplateDtoModelPrimitives, EmailTemplateDtoModelSelector } from './EmailTemplateDtoModel.base';

/**
 * EmailTemplateDtoModel
 */
export const EmailTemplateDtoModel = EmailTemplateDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }))
  .views(self => ({
    parsedBody() {
      if (self.body && getAppRoot(self).organization?.name) {
        return enrichTemplateWithOrganizationData(self.body, getAppRoot(self).organization.name as string);
      }

      return self.body;
    },
  }));
